// Dummy function. routePlugin.js should replace instances of this function with the actual route string during compile time.
const route = (routeName: string, params?) => {
  throw "Dummy route function should not be called at runtime!"
};

export default route;